import FingoCircularProgressLoader from '@fingo/lib/components/loader/FingoCircularProgressLoader';
import PrivateRoute from '@fingo/lib/components/router/PrivateRoute';
import useEnvironment from '@fingo/lib/hooks/useEnvironment';
import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import Landing from '@fingo/lib/views/Landing';
import appRoutes from './app-routes';
import BANCONEXION_URL from './constants/banconexion-url';

const AppRoutes = () => {
  const environment = useEnvironment();
  return (
    <Suspense fallback={(<FingoCircularProgressLoader showEmptyLogo />)}>
      <Switch>
        {appRoutes.map(({ path, component, private: isPrivate }) => {
          if (isPrivate) {
            return <PrivateRoute key={path} path={path} component={component} />;
          }
          return <Route key={path} exact path={path} component={component} />;
        })}
        {/* Catch-all route for any unmatched paths */}
        <Route>
          <Landing
            externalRedirectPath={environment.isLocalhost ? null : BANCONEXION_URL}
          />
        </Route>
      </Switch>
    </Suspense>
  );
};

export default AppRoutes;
